import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";

import { useGetUserInformation } from "../features/users";
import DashboardSkeleton from "./ui/DashboardSkeleton";

export function AppProvider() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const searchParams = new URLSearchParams(location.search);
  const adminToken = searchParams.get("adminToken") || "";

  const { isPending: isUserPending } = useGetUserInformation();

  useEffect(() => {
    if (adminToken) {
      Cookies.set("token", adminToken);
    }

    const token = Cookies.get("token");

    if (!token) {
      navigate("/auth");
    }

    setLoading(false);
  }, [adminToken]);

  if (loading || isUserPending) return <DashboardSkeleton />;

  return <Outlet />;
}
